module.exports = __webpack_public_path__ + "static/typescript-b0a4ba75f940b54e9d687cba42243573.jpg";